import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function usePaymentRefunds(params) {
  const { data, ...rest } = useQuery('paymentRefunds', () =>
    apiCalls.getPaymentRefunds(params).then(({ data: { paymentRefunds, totalCount } }) => ({
      paymentRefunds,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}

export function usePaymentRefundDelete() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ paymentRefund }) => apiCalls.deletePaymentRefund(paymentRefund.id), {
    onSuccess: () => {
      queryClient.invalidateQueries('paymentRefunds');
    },
  });
  return { deletePaymentRefund: mutate, ...rest };
}
